<div mat-dialog-content class="py-12">

  <div class="font-medium text-center text-3xl mb-12">Processing your order</div>

  <div class="">

    <div class="desktop:hidden med:hidden">

      @for (step of processSteps; track step) {
        <div [ngStyle]="{ 'display': step.id === currentStep ? 'flex' : 'none' }"  class="flex-grow flex flex-col justify-center items-center">
          <fa-icon [icon]="step.icon" class="text-6xl transition-colors" [ngClass]="step.status ? 'text-gwc-success-green' : 'text-gray-300'"></fa-icon>
          <div class="font-medium text-xl mt-3">{{ step.title }}</div>
          <div class="mt-3 flex items-align flex-col">
            <loading id="{{ step.id }}Loader" styling="pageloading-primary" message=" " [initialLoading]="true"></loading>
            @if (step.status) {
              <fa-icon [icon]="['fas', 'check-circle']" class="text-center text-5xl text-gwc-success-green"></fa-icon>
            }
          </div>
        </div>
      }
    </div>


    <div class="mobile:hidden flex items-start">

      @for (step of processSteps; track step) {
        <div class="flex-grow flex flex-col justify-center items-center">
          <fa-icon [icon]="step.icon" class="text-6xl transition-colors" [ngClass]="step.status ? 'text-gwc-success-green' : 'text-gray-300'"></fa-icon>
          <div class="font-medium text-xl mt-3">{{ step.title }}</div>
          <div class="mt-3 flex items-align flex-col">
            <loading id="{{ step.id }}Loader" styling="pageloading-primary" message=" " [initialLoading]="step.loading"></loading>
            @if (step.status) {
              <fa-icon [icon]="['fas', 'check-circle']" class="text-center text-5xl text-gwc-success-green"></fa-icon>
            }
          </div>
        </div>
      }

    </div>



  </div>

</div>
